export enum GzIzIntegrationStatus {
  LINKED = "linked",
  UNLINKED = "unlinked"
}

export enum CompanyViewType {
  MY_COMPANY = 'my-company',
  EDIT_COMPANY = 'edit-company'
}
